var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "&ns_svg;",
    xmlnsXlink: "&ns_xlink;",
    width: 50,
    height: 50,
    viewBox: "0 0 128 128",
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 4,
    y: 93,
    width: 80,
    height: 32
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 93,
    width: 80,
    height: 32,
    id: "network_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 6,
    y1: 114,
    x2: 84,
    y2: 114
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9775,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 103,
    style: {
      fill: "url(#XMLID_1_)"
    },
    width: 78,
    height: 22
  }))), /*#__PURE__*/React.createElement("g", {
    id: "network",
    style: {
      mask: "url(#network_1_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.9995,
    y1: 111.333,
    x2: 43.9995,
    y2: 124.166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#999999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D4D4D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#XMLID_2_)"
    },
    d: "M84,114H43v-1c0-1.103-0.897-2-2-2H22c-1.103,0-2,0.897-2,2v1H4v7h16v1 c0,1.103,0.897,2,2,2h19c1.103,0,2-0.897,2-2v-1h41V114z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.9995,
    y1: 112.333,
    x2: 43.9995,
    y2: 125.166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#999999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D4D4D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#XMLID_3_)"
    },
    d: "M84,115H43v-1c0-1.103-0.897-2-2-2H22c-1.103,0-2,0.897-2,2v1H4v7h16v1 c0,1.103,0.897,2,2,2h19c1.103,0,2-0.897,2-2v-1h41V115z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.9995,
    y1: 113.875,
    x2: 43.9995,
    y2: 119.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#737373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A1A1A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 113,
    style: {
      opacity: 0.8,
      fill: "url(#XMLID_4_)"
    },
    width: 80,
    height: 7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.9995,
    y1: 113.875,
    x2: 43.9995,
    y2: 119.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    style: {
      stopColor: "#B2B4B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1742,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2415,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3591,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5128,
    style: {
      stopColor: "#A9A9A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    style: {
      stopColor: "#595959"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#878787"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 114,
    style: {
      fill: "url(#XMLID_5_)"
    },
    width: 80,
    height: 5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.5,
    y1: 110.333,
    x2: 31.5,
    y2: 123.166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#737373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A1A1A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75,
      fill: "url(#XMLID_6_)"
    },
    d: "M22,110c-1.103,0-2,0.897-2,2v9c0,1.103,0.897,2,2,2h19c1.103,0,2-0.897,2-2v-9 c0-1.103-0.897-2-2-2H22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.5,
    y1: 111,
    x2: 31.5,
    y2: 122.1058
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    style: {
      stopColor: "#B2B4B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4082,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5328,
    style: {
      stopColor: "#A9A9A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6803,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    style: {
      stopColor: "#595959"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#878787"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#XMLID_7_)"
    },
    d: "M42,121c0,0.55-0.45,1-1,1H22c-0.55,0-1-0.45-1-1v-9c0-0.55,0.45-1,1-1h19c0.55,0,1,0.45,1,1 V121z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.7778,
    y1: 102.9502,
    x2: 34.2223,
    y2: 102.9502
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#737373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A1A1A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75,
      fill: "url(#XMLID_8_)"
    },
    d: "M29,93c-0.552,0-1,0.447-1,1v16.199c0,0.142,0.03,0.282,0.088,0.411 c0.042,0.094,0.07,2.29,3.378,2.29c3.286,0,3.387-2.169,3.432-2.262c0.067-0.137,0.102-0.287,0.102-0.439V94c0-0.553-0.448-1-1-1 H29z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.9951,
    y1: 102.9502,
    x2: 34.002,
    y2: 102.9502
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    style: {
      stopColor: "#B2B4B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1742,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5569,
    style: {
      stopColor: "#A9A9A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7627,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    style: {
      stopColor: "#595959"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#878787"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#XMLID_9_)"
    },
    d: "M34,110.199c0,0,0.167,1.701-2.534,1.701S29,110.199,29,110.199V94h5V110.199z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.7778,
    y1: 103.5,
    x2: 34.2223,
    y2: 103.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 103,
    style: {
      fill: "url(#XMLID_10_)"
    },
    width: 7,
    height: 1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.7778,
    y1: 104.5,
    x2: 34.2223,
    y2: 104.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#737373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A1A1A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 104,
    style: {
      opacity: 0.5,
      fill: "url(#XMLID_11_)"
    },
    width: 7,
    height: 1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.4272,
    y1: 112.4941,
    x2: 19.6182,
    y2: 122.9301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4326,
    style: {
      stopColor: "#1A1A1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#676767"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 113,
    style: {
      opacity: 0.3,
      fill: "url(#XMLID_12_)"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.4268,
    y1: 112.4932,
    x2: 43.6177,
    y2: 122.9306
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4326,
    style: {
      stopColor: "#1A1A1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#676767"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 113,
    style: {
      opacity: 0.3,
      fill: "url(#XMLID_13_)"
    },
    width: 1,
    height: 7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.9155,
    y1: 91.1152,
    x2: 55.8202,
    y2: 110.6698
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#999999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D4D4D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#XMLID_14_)"
    },
    d: "M0,96.969C0,101.766,4.52,104,6.5,104h98.342 c3.922-0.238,4.158-3.357,4.158-7.104v0.109C109,93.197,0,96.969,0,96.969z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.8511,
    y1: 91.5078,
    x2: 58.8261,
    y2: 111.7843
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#999999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D4D4D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#XMLID_15_)"
    },
    d: "M0,97.969C0,102.078,3.266,105,6.5,105h101.553 c3.922-0.238,7.114-0.754,7.114-4.5L115,98.005C115,94.296,0,95.861,0,97.969z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.9409,
    y1: 89.6006,
    x2: 60.2324,
    y2: 113.1264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#999999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D4D4D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#XMLID_16_)"
    },
    d: "M110.053,97.824L0,95.969v3C0,104.609,4.52,106,6.5,106h103.167 c1.729-0.104,3.551-0.264,5.05-0.729c1.903-0.591,3.283-1.675,3.283-3.771C118,101.5,116.206,97.824,110.053,97.824z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.3115,
    y1: 10.7583,
    x2: 58.863,
    y2: 110.2979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#999999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D4D4D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75,
      fill: "url(#XMLID_17_)"
    },
    d: "M6.946,16.1C3.116,16.1,0,19.209,0,23.031v73.038C0,99.891,3.116,103,6.946,103 h93.108c3.83,0,6.945-3.109,6.945-6.931V32.097c0-3.822-3.115-6.931-6.945-6.931H62.729c-2.793,0-6.33-1.492-8.801-3.713 c0,0-1.035-0.928-1.035-0.928c-2.114-1.899-5.372-4.425-9.246-4.425H6.946z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.979,
    y1: 15.0229,
    x2: 68.9291,
    y2: 107.2834
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2191,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6013,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3B3B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#XMLID_18_)"
    },
    d: "M106,96.069c0,3.263-2.676,5.931-5.945,5.931H6.946C3.676,102,1,99.332,1,96.069V23.031 C1,19.769,3.676,17.1,6.946,17.1h36.701c3.271,0,6.149,1.987,8.578,4.169l1.034,0.928c2.429,2.182,6.2,3.969,9.47,3.969h37.326 c3.27,0,5.945,2.668,5.945,5.931V96.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M100.055,26.167H62.729c-3.27,0-7.041-1.787-9.47-3.969l-1.034-0.928 c-2.428-2.182-5.307-4.169-8.578-4.169H6.946C3.676,17.1,1,19.769,1,23.031v1C1,20.769,3.676,18.1,6.946,18.1h36.701 c3.271,0,6.149,1.987,8.578,4.169l1.034,0.928c2.429,2.182,6.2,3.969,9.47,3.969h37.326c3.27,0,5.945,2.668,5.945,5.931v-1 C106,28.835,103.324,26.167,100.055,26.167z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.9219,
    y1: 23.2446,
    x2: 58.3703,
    y2: 104.0195
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9D9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3749,
    style: {
      stopColor: "#CECECE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3B3B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#XMLID_19_)"
    },
    d: "M3.344,99.816c0,0,0.984,0.168,1.615-0.284C5.625,99.054,6,97.695,6,95.896V54.132 c0-3.808,3.117-6.905,6.947-6.905h37.308c2.996,0,6.582-2.007,8.807-3.997l1.033-0.924c3.164-2.831,6.188-4.207,9.247-4.207H106 v-0.6H68.342c-3.059,0-6.083,1.376-9.247,4.207l-1.033,0.924c-2.225,1.989-5.811,3.997-8.807,3.997H11.947 C8.117,46.627,5,49.725,5,53.533v41.763c0.062,2.017-0.495,3.878-1.167,4.351C3.701,99.739,3.344,99.816,3.344,99.816z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.9907,
    y1: 39.2622,
    x2: 63.2101,
    y2: 110.0893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#999999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D4D4D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75,
      fill: "url(#XMLID_20_)"
    },
    d: "M69.342,38.1c-3.059,0-6.083,1.376-9.247,4.207l-1.033,0.924 c-2.225,1.989-5.811,3.996-8.807,3.996H12.947C9.117,47.227,6,50.325,6,54.132v41.763c0,1.847-0.37,3.165-1.015,3.619 C4.607,99.78,3.94,99.97,3.171,99.78c-0.762-0.188-1.067-0.562-1.563-1.022c-0.241,0.421,0.332,2.104,0.705,2.414 c0.219,0.183,2.062,1.719,4.344,1.719L109.053,103c3.923-0.238,6.947-3.358,6.947-7.104V45.005c0-3.807-3.116-6.905-6.947-6.905 H69.342z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_21_",
    cx: 79.6152,
    cy: 116.7344,
    r: 88.0417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDD70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4225,
    style: {
      stopColor: "#FFAB43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8022,
    style: {
      stopColor: "#FF841F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7512"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#XMLID_21_)"
    },
    d: "M7,95.896c0,3.417-1.516,5.839-4.047,4.558c0,0,1.859,1.547,3.547,1.547s102.553,0,102.553,0 c3.271-0.2,5.947-2.857,5.947-6.104V45.005c0-3.248-2.676-5.905-5.947-5.905H69.342c-3.271,0-6.151,1.779-8.58,3.952l-1.033,0.924 c-2.43,2.172-6.202,4.251-9.474,4.251H12.947C9.676,48.227,7,50.884,7,54.132V95.896z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_22_",
    cx: 126.5,
    cy: 130.1982,
    r: 82.3742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2D26A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2621,
    style: {
      stopColor: "#F6B650"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7541,
    style: {
      stopColor: "#FC8723"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7512"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#XMLID_22_)"
    },
    d: "M109.053,39.1H106V102c2.578,0,3.053,0,3.053,0c3.271-0.2,5.947-2.857,5.947-6.104V45.005 C115,41.757,112.324,39.1,109.053,39.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.5059,
    y1: 35.3008,
    x2: 40.7597,
    y2: 115.4526
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDD70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3826,
    style: {
      stopColor: "#FFB047"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    style: {
      stopColor: "#FF8521"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7512"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#XMLID_23_)"
    },
    d: "M109.053,100c0,0-100.947-0.52-102.553,0c-0.324,0.104-0.608,0.189-0.866,0.26 c-0.623,0.479-1.739,0.85-2.638,0.19C3.479,100.83,5.083,102,6.5,102c1.688,0,102.553,0,102.553,0 c3.271-0.2,5.947-2.857,5.947-6.104v-1C115,98.143,112.324,99.8,109.053,100z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_24_",
    cx: 87.5469,
    cy: 108.1338,
    r: 112.4545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF3CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1912,
    style: {
      stopColor: "#FFDBAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5738,
    style: {
      stopColor: "#FFB06C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    style: {
      stopColor: "#FF9445"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF8A36"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#XMLID_24_)"
    },
    d: "M58.636,69.891C86.75,66.5,115,65.75,115,65.75V45.005c0-3.248-2.676-5.905-5.947-5.905 H69.342c-3.271,0-6.151,1.779-8.58,3.952l-1.033,0.924c-2.43,2.172-6.202,4.251-9.474,4.251H12.947C9.676,48.227,7,50.884,7,54.132 V84.75C7,84.75,30.521,73.281,58.636,69.891z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.6372,
    y1: 28.6401,
    x2: 65.5115,
    y2: 120.5861
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBDBA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7512"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#XMLID_25_)"
    },
    d: "M109.053,39.1H69.342c-3.271,0-6.151,1.779-8.58,3.952l-1.033,0.924 c-2.43,2.172-6.202,4.251-9.474,4.251H12.947C9.676,48.227,7,50.884,7,54.132v1c0-3.248,2.676-5.905,5.947-5.905h37.308 c3.271,0,7.044-2.079,9.474-4.251l1.033-0.924c2.429-2.173,5.309-3.952,8.58-3.952h39.711c3.271,0,5.947,2.657,5.947,5.905v-1 C115,41.757,112.324,39.1,109.053,39.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.9541,
    y1: 11.4053,
    x2: 108.0303,
    y2: 106.0095
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#999999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D4D4D"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 39,
    style: {
      opacity: 0.15,
      fill: "url(#XMLID_26_)"
    },
    width: 1,
    height: 63
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3AF61"
    },
    d: "M42,24c0,1.1-0.9,2-2,2H9c-1.1,0-2-0.9-2-2v-2c0-1.1,0.9-2,2-2h31c1.1,0,2,0.9,2,2V24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M8.5,42C7.672,42,7,42.672,7,43.5S7.672,45,8.5,45s1.5-0.672,1.5-1.5S9.328,42,8.5,42z M17.5,42 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S18.328,42,17.5,42z M26.5,42c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S27.328,42,26.5,42z M35.5,42c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5 S36.328,42,35.5,42z M44.5,42c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S45.328,42,44.5,42z M53.5,42 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S54.328,42,53.5,42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.07,
      fill: "#802600"
    },
    d: "M8.5,51C7.672,51,7,51.672,7,52.5S7.672,54,8.5,54s1.5-0.672,1.5-1.5S9.328,51,8.5,51z  M17.5,51c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S18.328,51,17.5,51z M26.5,51c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S27.328,51,26.5,51z M35.5,51c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5 S36.328,51,35.5,51z M44.5,51c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S45.328,51,44.5,51z M53.5,51 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S54.328,51,53.5,51z M62.5,51c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S63.328,51,62.5,51z M71.5,51c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5 S72.328,51,71.5,51z M80.5,51c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S81.328,51,80.5,51z M89.5,51 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S90.328,51,89.5,51z M98.5,51c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S99.328,51,98.5,51z M62.5,42c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5 S63.328,42,62.5,42z M71.5,42c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S72.328,42,71.5,42z M80.5,42 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S81.328,42,80.5,42z M89.5,42c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S90.328,42,89.5,42z M98.5,45c0.828,0,1.5-0.672,1.5-1.5S99.328,42,98.5,42S97,42.672,97,43.5 S97.672,45,98.5,45z M8.5,60C7.672,60,7,60.672,7,61.5S7.672,63,8.5,63s1.5-0.672,1.5-1.5S9.328,60,8.5,60z M17.5,60 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S18.328,60,17.5,60z M26.5,60c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S27.328,60,26.5,60z M35.5,60c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5 S36.328,60,35.5,60z M44.5,60c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S45.328,60,44.5,60z M53.5,60 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S54.328,60,53.5,60z M62.5,60c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S63.328,60,62.5,60z M71.5,60c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5 S72.328,60,71.5,60z M80.5,60c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S81.328,60,80.5,60z M89.5,60 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S90.328,60,89.5,60z M98.5,60c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S99.328,60,98.5,60z M8.5,69C7.672,69,7,69.672,7,70.5S7.672,72,8.5,72s1.5-0.672,1.5-1.5 S9.328,69,8.5,69z M17.5,69c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S18.328,69,17.5,69z M26.5,69 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S27.328,69,26.5,69z M35.5,69c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S36.328,69,35.5,69z M44.5,69c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5 S45.328,69,44.5,69z M53.5,69c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S54.328,69,53.5,69z M62.5,69 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S63.328,69,62.5,69z M71.5,69c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S72.328,69,71.5,69z M80.5,69c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5 S81.328,69,80.5,69z M89.5,69c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S90.328,69,89.5,69z M98.5,69 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S99.328,69,98.5,69z M8.5,78C7.672,78,7,78.672,7,79.5 S7.672,81,8.5,81s1.5-0.672,1.5-1.5S9.328,78,8.5,78z M17.5,78c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5 S18.328,78,17.5,78z M26.5,78c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S27.328,78,26.5,78z M35.5,78 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S36.328,78,35.5,78z M44.5,78c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S45.328,78,44.5,78z M53.5,78c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5 S54.328,78,53.5,78z M62.5,78c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S63.328,78,62.5,78z M71.5,78 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S72.328,78,71.5,78z M80.5,78c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S81.328,78,80.5,78z M89.5,78c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5 S90.328,78,89.5,78z M98.5,78c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S99.328,78,98.5,78z M8.5,87 C7.672,87,7,87.672,7,88.5S7.672,90,8.5,90s1.5-0.672,1.5-1.5S9.328,87,8.5,87z M17.5,87c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S18.328,87,17.5,87z M26.5,87c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5 S27.328,87,26.5,87z M35.5,87c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S36.328,87,35.5,87z M44.5,87 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S45.328,87,44.5,87z M53.5,87c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S54.328,87,53.5,87z M62.5,87c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5 S63.328,87,62.5,87z M71.5,87c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S72.328,87,71.5,87z M80.5,87 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S81.328,87,80.5,87z M89.5,87c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S90.328,87,89.5,87z M98.5,87c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5 S99.328,87,98.5,87z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "orrec"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F36600"
    },
    d: "M62,103c0-3.85,3.15-7,7-7h52c3.85,0,7,3.15,7,7v11 c0,3.85-3.15,7-7,7H69c-3.85,0-7-3.15-7-7V103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M83.709,105.039c-0.792-0.342-1.674-0.539-2.557-0.539c-0.863,0-1.979,0.378-1.979,1.746 c0,2.178,5.509,1.26,5.509,5.472c0,2.754-2.179,3.798-4.717,3.798c-1.367,0-1.98-0.18-3.222-0.486l0.233-2.268 c0.864,0.469,1.854,0.773,2.844,0.773c0.955,0,2.232-0.485,2.232-1.619c0-2.395-5.508-1.404-5.508-5.562 c0-2.808,2.178-3.834,4.393-3.834c1.08,0,2.088,0.145,3.006,0.45L83.709,105.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M86.967,102.736h4.032l2.988,9.521h0.035l2.988-9.521h4.032V115.3h-2.412v-10.368h-0.036 L95.211,115.3h-2.412l-3.384-10.368l-0.036,0.036V115.3h-2.412V102.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M103.959,102.736h4.392c1.62,0,4.051,0.467,4.051,3.221c0,1.494-1.009,2.539-2.502,2.809v0.036 c1.71,0.162,2.88,1.313,2.88,2.862c0,3.168-2.845,3.636-4.429,3.636h-4.392V102.736z M106.479,107.812h1.026 c1.062,0,2.376-0.233,2.376-1.53c0-1.457-1.278-1.565-2.43-1.565h-0.973V107.812z M106.479,113.32h1.188 c1.17,0,2.592-0.289,2.592-1.746c0-1.639-1.332-1.891-2.592-1.891h-1.188V113.32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmb);
export default __webpack_public_path__ + "static/media/smb.484d6654be906f30424404aad91cd2e8.svg";
export { ForwardRef as ReactComponent };